import { getCookieValue } from '../../../assets/js/utils/getCookieValue';
import { getXhrDomain } from '../../../assets/js/utils/getXhrDomain';

async function updateAntiForgeryTokenFieldValues() {
    try {
        const requestVerificationInputFields = document.querySelectorAll(
            'input[name=__RequestVerificationToken]',
        );
        const antiForgeryResponse = await fetch(getXhrDomain() + '/antiforgery/token', {
            method: 'GET',
        });

        if (!antiForgeryResponse.ok) {
            const message = `An error has occurred: ${antiForgeryResponse.status}`;
            throw new Error(message);
        }

        requestVerificationInputFields.forEach((input) => {
            input.value = getCookieValue('XSRF-TOKEN');
        });
    } catch (error) {
        console.error('error', error.message);
    }
}

export { updateAntiForgeryTokenFieldValues };
